// =============================================================================
// Derived reads over the voiceAgents slice. State is read inline elsewhere via
// useSelector((state) => state.voiceAgents.…); these two derivations compose
// more than one field, so they live here as pure functions and are called from
// an inline selector: useSelector((state) => getSelectedAgent(state.voiceAgents)).
// =============================================================================

export const getSelectedAgent = (voiceAgents) => {
  const id = voiceAgents.selectedAgentId
  return id ? voiceAgents.detailById[id] || null : null
}

export const getNodeById = (voiceAgents, nodeId) => {
  const agent = getSelectedAgent(voiceAgents)
  if (!agent || !nodeId || !Array.isArray(agent.nodes)) {
    return null
  }
  return agent.nodes.find((node) => node.id === nodeId) || null
}

export const getSelectedNode = (voiceAgents) => getNodeById(voiceAgents, voiceAgents.selectedNodeId)
